import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { getApi } from '../api'

/** The engine moves every geofence using the type to its parent before deleting it. */
export default () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ accountId, id }: { accountId: number; id: number }) => {
      const { api, baseURL } = getApi()
      return api.delete(`/api/v2/accounts/${accountId}/place-types/${id}`, {
        baseURL,
      })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['account-place-types'] })
    },
  })
}
